// src/hooks/hotelRatings/useRestoreHotelRating.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { restoreHotelRating as restoreHotelRatingAPI } from "../../api/apiHotelRatings";
import parseError from "../../utils/parseError";

const useRestoreHotelRating = () => {
    const queryClient = useQueryClient();

    const { mutate: restore, isPending: isRestoring } = useMutation({
        mutationFn: restoreHotelRatingAPI,
        onSuccess: (res) => {
            const message = res?.message || "Hotel rating restored successfully";
            toast.success(message);
            queryClient.invalidateQueries({ queryKey: ["hotelRatings"] });
        },
        onError: (error) => {
            const msg = parseError(error);
            toast.error(msg || "Failed to restore hotel rating");
        },
    });

    return { restoreHotelRating: restore, isRestore: isRestoring };
};

export default useRestoreHotelRating;
